import React, { Fragment } from 'react';
import PropTypes from 'prop-types';

const DeleteExpressionTarget = props => {
  return (
    <Fragment>
      <div className="ibox-spacer-hline" />
      <div
        className="autocode-delete-definition"
        data-test="definitionDeleteComponent"
      >
        <button type="button" onClick={props.onDelete}>
          Delete
        </button>
      </div>
    </Fragment>
  );
};

DeleteExpressionTarget.propTypes = {
  onDelete: PropTypes.func,
};

export default DeleteExpressionTarget;
